<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title id="v_card_inEditT"> Edit Template </v-card-title>
    <v-icon
      class="close"
      size="35"
      @click="$store.commit('common/changeEditTemplateModalView')"
      >mdi-window-close</v-icon
    >

    <!-- search -->
    <div id="search">
      <!-- search by word -->
      <div id="searchByWord">
        <div id="searchByWordDiv">Category</div>
        <v-select
          v-model="categoryColumn"
          label="All"
          :items="categories"
          item-text="name"
          item-value="value"
          class="searchByWordContent"
          single-line
          color="#05523E"
        />
        <v-text-field
          v-model="search"
          class="searchByWordContent"
          placeholder="Search"
          clearable
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          id="searchByWordBtn"
          @click="searchByWord"
          >Search</v-btn
        >
      </div>
      <!-- search by department -->
      <div id="searchByDep">
        <div id="searchByDepDiv">Department</div>
        <v-select
          v-model="departmentColumn"
          label="All"
          @input="searchByDepartment"
          :items="$store.state.invoice.departments"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
      </div>
    </div>
    <div v-show="isShow" style="margin: 0.5% 3.5% auto; padding-bottom: 20px">
      <v-data-table
        :headers="headers"
        :items="$store.state.invoice.inventoryList"
        :page.sync="page_No"
        :items-per-page="10"
        hide-default-footer
        class="elevation-3"
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                <thead>
                    <tr>
                        <th v-for="h in headers" v-bind:key="h.text">
                            <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                        </th>
                    </tr>
                </thead>
                </template> -->
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.itemNum }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.vendorName }}</td>
            <td>{{ item.department }}</td>
            <td>
              <v-btn
                v-if="item.inTemplate"
                class="elevation-0 pa-0 ma-0"
                style="width: 10px; margin: 0; backgroundcolor: transparent"
                @click="removeTemplate(item.itemNum)"
              >
                <v-icon size="32" color="#D86C6C">mdi-minus-circle</v-icon>
              </v-btn>
              <v-btn
                v-else
                class="elevation-0 pa-0 ma-0"
                style="width: 10px; margin: 0; backgroundcolor: transparent"
                @click="addTemplate(item.itemNum)"
              >
                <v-icon size="32" color="#05523E">mdi-plus-circle</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          style="padding-top: 8px"
          color="#05523E"
          v-model="page_No"
          :length="$store.state.invoice.inventoryPages"
          :total-visible="10"
          @input="movePage"
        />
      </div>
    </div>
    <div
      v-show="!$store.state.common.isLoading && !isShow"
      style="font-size: 20px"
    >
      <div
        style="
          margin: 0% 0% 0% 500px;
          font-size: 40px;
          color: #05523e;
          font-weight: bold;
        "
      >
        No data was retrieved.
      </div>
      <img
        style="width: 600px; height: 500px; margin: 0% 0% 0% 400px"
        src="@/assets/noData.jpg"
      />
    </div>
  </v-card>
</template>

<script>
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import { GETINVENTORYLENGTH } from "@/graphql/InvoiceQueries.js";

export default {
  data() {
    return {
      departmentColumn: "",
      selectedDepartment: [],
      categoryColumn: "",
      search: "",
      page_No: 1,
      headers: [
        {
          text: "Item Number",
          align: "start",
          value: "itemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Item Name",
          value: "itemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Vendor Name",
          value: "vendorName",
          //   sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Department",
          value: "department",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "", value: "inTemplate", sortable: false },
      ],
      categories: [
        { name: "Category", value: "", sort: (a, b) => a.localeCompare(b) },
        {
          name: "Item Number",
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Item Name",
          value: "ItemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Vendor Name",
          value: "Company",
          sort: (a, b) => a.localeCompare(b),
        },
      ],
      custNum: this.custNumber,
      isShow: true,
      loading: false,
    };
  },
  async created() {
    await this.searchInventory();
  },
  props: ["custNumber"],
  methods: {
    async getInventoriesLength() {
      try {
        const req = {
          Column: this.categoryColumn,
          Search: this.search,
          Dept_ID: this.selectedDepartment,
        };

        const inventoryPage = await runGqlQuery(GETINVENTORYLENGTH, req);

        this.$store.state.invoice.inventoryPages = Math.ceil(
          inventoryPage.getInventoriesLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async searchByWord() {
      try {
        if (this.categoryColumn === "" && this.search !== "") {
          return this.$store.commit("common/snackErrOn", {
            text: "Please select a category!",
          });
        }

        await this.searchInventory();
      } catch (err) {
        console.error(err);
      }
    },
    async searchByDepartment() {
      try {
        if (this.departmentColumn !== "") {
          this.selectedDepartment = [this.departmentColumn];
        } else {
          this.selectedDepartment = [];
        }

        await this.searchInventory();
      } catch (err) {
        console.error(err);
      }
    },
    async searchInventory() {
      try {
        this.loading = true;
        await this.getInventoriesLength();
        this.page_No = 1;
        await this.getInventories();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async getInventories() {
      try {
        await this.$store.dispatch("invoice/getTemplates", {
          CustNum: this.custNum,
        });

        const req = {
          Column: this.categoryColumn,
          Search: this.search,
          Dept_ID: this.selectedDepartment,
          Page_No: this.page_No - 1,
          Page_Size: 10,
          belong: "Template",
        };

        await this.$store.dispatch("invoice/getInventoryList", req);
      } catch (err) {
        console.error(err);
      }
    },
    async addTemplate(itemNum) {
      try {
        await this.$store.dispatch("invoice/addTemplate", {
          custNum: this.custNum,
          itemNum: itemNum,
        });
        await this.getInventories();
        await this.$emit("getTemplateOne");
      } catch (err) {
        console.error(err);
      }
    },
    async removeTemplate(itemNum) {
      try {
        let id;
        this.$store.state.invoice.templateList.forEach((data) => {
          if (data.itemNum == itemNum) {
            id = data._id;
          }
        });
        await this.$store.dispatch("invoice/deleteTemplate", { _id: id });
        await this.getInventories();
        await this.$emit("getTemplateOne");
      } catch (err) {
        console.error(err);
      }
    },
    async movePage(page) {
      try {
        this.loading = true;
        this.page_No = page;
        await this.getInventories();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#v_card_inEditT {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 33px;
  font-weight: bold;
  color: #05523e;
  padding-top: 40px;
}
#search {
  margin: 1.5% 3.5% auto;
}
#searchByWord {
  display: flex;
  flex-wrap: wrap;
  height: 50px;
}
#searchByWordDiv {
  font-size: 23px;
  font-weight: bold;
  width: 150px;
  padding-top: 15px;
}
.searchByWordContent {
  max-width: 160px;
  min-width: 100px;
  margin-right: 20px;
}
#searchByWordBtn {
  max-width: 130px;
  min-width: 110px;
  margin-top: 15px;
}
#searchByDep {
  display: flex;
  flex-wrap: wrap;
}
#searchByDepDiv {
  font-size: 23px;
  font-weight: bold;
  width: 150px;
  line-height: 65px;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  color: black;
}
</style>
